import React, {useEffect, useMemo, useState} from "react";
import {useForm} from "react-hook-form";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {AziendaEditorProps} from "../Azienda.generalita.page";
import {useGetAziendeFornitoriQuery} from "@commons/features/azienda/tabelle/aziendaMapping.api";
import {ComboBoxFornitore} from "../../../components/comboBox/ComboBoxInquadramento";
import FormButtons from "../../../components/FormButtons";
import {Domain} from "@commons/mapping/LoginResultRecord";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectDomini, selectToken} from "@commons/core.slice";
import TelefonoButton from "../../../components/TelefonoButton";
import FaxButton from "../../../components/FaxButton";
import EmailButton from "../../../components/EmailButton";
import {FornitoreRecord} from "@commons/mapping/FornitoreRecord";
import {TokenRecord} from "@commons/mapping/TokenRecord";


const FornitoriEditor: React.FC<AziendaEditorProps> = ({defaultValues, resource, onSubmit, onCancel}) => {
    const {handleSubmit, reset, control, formState: {errors}} = useForm<AziendaRecord>();

    const localToken: TokenRecord | null = useAppSelector(selectToken);
    const domini: Domain[] = useAppSelector(selectDomini);

    const {data: dataFornitori, isLoading: isLoadingFornitori} = useGetAziendeFornitoriQuery({idDominio: getCurrentDomain()!});

    let [fornCDL, setFornCDL] = useState<FornitoreRecord[]>([]);
    let [fornCED, setFornCED] = useState<FornitoreRecord[]>([]);
    let [fornCommercialista, setFornCommercialista] = useState<FornitoreRecord[]>([]);
    // let [fornAltro, setFornAltro] = useState<FornitoreRecord[]>([]);

    const initialValues: AziendaRecord = useMemo(() => {
        return {
            ...defaultValues, ...resource,
        };
    }, [resource, defaultValues]);

    useEffect(() => {
        reset(initialValues)
        if (dataFornitori) {
            setFornCDL(dataFornitori.filter((v) => v.tipo === 'CDL'));
            setFornCED(dataFornitori.filter((v) => v.tipo === 'CED'));
            setFornCommercialista(dataFornitori.filter((v) => v.tipo === 'COMMERCIALISTA'));
            // setFornAltro(dataFornitori.filter((v) => v.tipo === 'ALTRO'));
        }
    }, [resource, dataFornitori]);

    function getCurrentDomain() {
        const current = domini.filter((dominio) => (dominio.current));
        return current.length > 0 ? current[0].idDomain : (localToken ? localToken.idDominio : undefined);
    }

    const CONTACTS_BTNS = <div className="sm1-2P inline-flex gap-4 items-end">
        <div className="items-center bg-gray-200 rounded h-9 shadow-sm">
            <TelefonoButton telefono={resource.contatto ? resource.contatto.telefono : undefined}/>
        </div>
        <div className="flex items-center bg-gray-200 rounded h-9 shadow-sm">
            <FaxButton fax={resource.contatto ? resource.contatto.fax : undefined}/>
        </div>
        <div className="flex items-center bg-gray-200 rounded h-9 shadow-sm">
            <EmailButton email={resource.contatto ? resource.contatto.email : undefined}/>
        </div>
    </div>

    return <>

        <form className="p-1" onSubmit={handleSubmit(onSubmit)}>

            <div className="flexRowWrapFull">
                <div className="sm1-2P">
                    <ComboBoxFornitore<AziendaRecord> label="Consulente del lavoro" data={fornCDL} isLoading={isLoadingFornitori} control={control}
                                                      disabled={!AziendaRecord.isMaster(resource)} name="idCDL" defaultValue={defaultValues.idCDL}/>
                </div>

                {CONTACTS_BTNS}
            </div>

            <div className="flexRowWrapFull">
                <div className="sm1-2P">
                    <ComboBoxFornitore label="Centro elaborazione dati"
                                       disabled={!AziendaRecord.isMaster(resource)}
                                       data={fornCED} isLoading={isLoadingFornitori}
                                       control={control} name="idCED" defaultValue={initialValues.idCED}/>
                </div>
                {CONTACTS_BTNS}
            </div>

            <div className="flexRowWrapFull">
                <div className="sm1-2P">
                    <ComboBoxFornitore label="Commercialista"
                                       disabled={!AziendaRecord.isMaster(resource)}
                                       data={fornCommercialista} isLoading={isLoadingFornitori}
                                       control={control} name="idCommercialista" defaultValue={initialValues.idCommercialista}/>
                </div>

                {CONTACTS_BTNS}
            </div>

            <div className="flexRowWrapFull">
                <div className="sm1-2P">
                    <ComboBoxFornitore label="Responsabile del trattamento dei dati personali D. L g s. 196/03"
                                       disabled={!AziendaRecord.isMaster(resource)}
                                       data={dataFornitori} isLoading={isLoadingFornitori}
                                       control={control} name="idRDT_L196" defaultValue={initialValues.idRDT_L196}/>
                </div>

                {CONTACTS_BTNS}
            </div>

            <FormButtons onCancel={onCancel} resource={resource} readonly={!AziendaRecord.isMaster(resource)}/>

        </form>

    </>
}
export default FornitoriEditor;
